import { Component, OnInit } from '@angular/core';
import { ThreatmetrixService } from '@freelancer/threatmetrix';

@Component({
  selector: 'webapp-compat-threatmetrix',
  template: ``,
})
export class CompatThreatmetrixComponent implements OnInit {
  constructor(private threatMetrixService: ThreatmetrixService) {}

  ngOnInit() {
    const w = window as any;
    // Load the external script on page load
    this.threatMetrixService.getSession();
    w.webappCompatThreatmetrix = {
      getSession: this.threatMetrixService.getSession,
    };
  }
}
